/**
 * This can be used when you want to compose modules in react rather in a surface
 * This will split the parent mutate function into mutate functions compatible with the children
 *
 * @param {function} mutate - The mutate function of the parent.
 * @param {Object} mutationArgs - the args that the derived mutate function should receive.
 * @returns The mutate function suitable for the child
 */
export const deriveMutateOfChild = ({
  mutate,
  mutationArgs
}) => mutation => {
  if (mutation === null) {
    return mutation;
  }
  mutate(current => {
    return {
      ...current,
      ...(typeof mutation === 'function' ? mutation(mutationArgs) : mutationArgs)
    };
  });
};